<template>
    <div>
        <div v-if="!isLoading" class="line-item statistics">
            <div class="statistic">
                <strong>{{ analytics.total }}</strong>
                <span>Peak Usage</span>
            </div>
            <div class="statistic">
                <strong>{{ analytics.usage.languageData ? analytics.usage.languageData.length : 0 }}</strong>
                <span>Languages</span>
            </div>
        </div>
        <div v-if="!isLoading" class="analytics-chart">
            <line-chart
                v-if="analytics.usage.languageData" :colors="colors" :curve="false"
                :data="analytics.usage.languageData" lineWidth="1" legend="none" height="400px"
            />
            <div v-else-if="!isLoading" class="centered">No Analytics data for period.</div>
        </div>
        <div v-if="!isLoading" class="data-table">
            <table>
                <thead>
                <tr>
                    <th>
                        <span v-if="analytics.usage.languageData" class="sort-el">
                            <a>Language</a>
                        </span>
                    </th>
                    <th class="right-align half-cell">
                        <span v-if="analytics.usage.languageData" class="sort-el">
                            <a>Peak User Sessions</a>
                        </span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(language, index) in analytics.usage.languageData" :key="index">
                    <td>
                        <md-icon class="marker" v-bind:style="{ color: language.color }">fiber_manual_record</md-icon>
                        {{ language.name }}
                    </td>
                    <td class="right-align">{{ language.total }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  data () {
    return {};
  },
  computed: {
    ...mapGetters('analytics', {analytics: 'analytics', colors: 'getColors', isLoading: 'isLoading'})
  },
  methods: {
    toggleLanguage ($language) {

    }
  },
  async mounted () {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/AnalyticsAudience.vue